import { render, staticRenderFns } from "./linkman.vue?vue&type=template&id=3f0adbb7&scoped=true&"
import script from "./linkman.vue?vue&type=script&lang=js&"
export * from "./linkman.vue?vue&type=script&lang=js&"
import style0 from "./linkman.vue?vue&type=style&index=0&id=3f0adbb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0adbb7",
  null
  
)

export default component.exports